import React from 'react'
import { Option } from '../common/OptionInput'

export const AddAnchor = ({ link, onLinkChange, onTypeChange, type, anchorsList = [] }) => {
    return (
        <>
            <Option
                id="anchor"
                checked={type}
                onChange={onTypeChange}
                text="Add Anchor"
                value="anchor"
                name="anchor"
            >
                <select
                    disabled={type !== "anchor"}
                    value={type == "anchor" ? link : ""}
                    onChange={onLinkChange}
                >
                    <option value="">Choose a section or component</option>
                    {anchorsList.map((item, index) => {
                        return (
                            <option value={item.id} key={index}>
                                {item.name}
                            </option>
                        );
                    })}
                </select>
            </Option>

            {type == "anchor" && (
                <small className="linkToPageNote">
                    This button will now lead directly to your chosen section. Ready to anchor your experience? ⚓️🔗
                </small>
            )}
        </>
    )
}
